/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EntityType } from '../model';
// @ts-ignore
import { PostEntityCreationRuleBasic } from '../model';
// @ts-ignore
import { PostEntityCreationRuleDetail } from '../model';
// @ts-ignore
import { PostEntityCreationRuleRequest } from '../model';
/**
 * PostEntityCreationRuleApi - axios parameter creator
 * @export
 */
export const PostEntityCreationRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new Post Entity Creation Rule
         * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostEntityCreationRule: async (postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postEntityCreationRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Post Entity Creation Rule by id.
         * @param {number} id id of rule to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostEntityCreationRule: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePostEntityCreationRule', 'id', id)
            const localVarPath = `/admin/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single Post Entity Creation Rule by id if it exists.
         * @param {number} id id of rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostEntityCreationRule: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPostEntityCreationRule', 'id', id)
            const localVarPath = `/admin/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all Post Entity Creation Rules for the given entityType.
         * @param {number} entityType Entity Type to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostEntityCreationRules: async (entityType: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getPostEntityCreationRules', 'entityType', entityType)
            const localVarPath = `/admin/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the selected target entity type for rule administrators. Authorized by EntityType.ADMIN rather than the caller\'s Entity Type scope, so an administrator can load any target the target picker offers. Confined to the caller\'s effective organization; an entity type in another organization is reported exactly as a missing one.
         * @summary Get one target entity type for the Post Entity Creation Rule editor
         * @param {number} id Target Entity Type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetEntityType: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTargetEntityType', 'id', id)
            const localVarPath = `/admin/rules/targetEntityTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of entity types that can be used as targets for post-entity creation rules. This excludes the source entity type itself, entity types with EAV storage, entity types with TIME_SERIES_SUB_ENTITY feature, and entity types that would create cyclical dependencies.
         * @summary Get valid target entity types for Post Entity Creation Rules
         * @param {number} entityType Source Entity Type to get valid targets for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetEntityTypes: async (entityType: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getTargetEntityTypes', 'entityType', entityType)
            const localVarPath = `/admin/rules/targetEntityTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Post Entity Creation Rule by id.
         * @param {number} id id of rule to update
         * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePostEntityCreationRule: async (id: number, postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePostEntityCreationRule', 'id', id)
            const localVarPath = `/admin/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postEntityCreationRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostEntityCreationRuleApi - functional programming interface
 * @export
 */
export const PostEntityCreationRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostEntityCreationRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new Post Entity Creation Rule
         * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPostEntityCreationRule(postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostEntityCreationRuleDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPostEntityCreationRule(postEntityCreationRuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a Post Entity Creation Rule by id.
         * @param {number} id id of rule to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePostEntityCreationRule(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePostEntityCreationRule(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single Post Entity Creation Rule by id if it exists.
         * @param {number} id id of rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostEntityCreationRule(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostEntityCreationRuleDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostEntityCreationRule(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets all Post Entity Creation Rules for the given entityType.
         * @param {number} entityType Entity Type to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostEntityCreationRules(entityType: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostEntityCreationRuleBasic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostEntityCreationRules(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the selected target entity type for rule administrators. Authorized by EntityType.ADMIN rather than the caller\'s Entity Type scope, so an administrator can load any target the target picker offers. Confined to the caller\'s effective organization; an entity type in another organization is reported exactly as a missing one.
         * @summary Get one target entity type for the Post Entity Creation Rule editor
         * @param {number} id Target Entity Type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTargetEntityType(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTargetEntityType(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a list of entity types that can be used as targets for post-entity creation rules. This excludes the source entity type itself, entity types with EAV storage, entity types with TIME_SERIES_SUB_ENTITY feature, and entity types that would create cyclical dependencies.
         * @summary Get valid target entity types for Post Entity Creation Rules
         * @param {number} entityType Source Entity Type to get valid targets for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTargetEntityTypes(entityType: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTargetEntityTypes(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a Post Entity Creation Rule by id.
         * @param {number} id id of rule to update
         * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePostEntityCreationRule(id: number, postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostEntityCreationRuleDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePostEntityCreationRule(id, postEntityCreationRuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PostEntityCreationRuleApi - factory interface
 * @export
 */
export const PostEntityCreationRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostEntityCreationRuleApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new Post Entity Creation Rule
         * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostEntityCreationRule(postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options?: any): AxiosPromise<PostEntityCreationRuleDetail> {
            return localVarFp.createPostEntityCreationRule(postEntityCreationRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Post Entity Creation Rule by id.
         * @param {number} id id of rule to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostEntityCreationRule(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deletePostEntityCreationRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single Post Entity Creation Rule by id if it exists.
         * @param {number} id id of rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostEntityCreationRule(id: number, options?: any): AxiosPromise<PostEntityCreationRuleDetail> {
            return localVarFp.getPostEntityCreationRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all Post Entity Creation Rules for the given entityType.
         * @param {number} entityType Entity Type to filter by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostEntityCreationRules(entityType: number, options?: any): AxiosPromise<Array<PostEntityCreationRuleBasic>> {
            return localVarFp.getPostEntityCreationRules(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the selected target entity type for rule administrators. Authorized by EntityType.ADMIN rather than the caller\'s Entity Type scope, so an administrator can load any target the target picker offers. Confined to the caller\'s effective organization; an entity type in another organization is reported exactly as a missing one.
         * @summary Get one target entity type for the Post Entity Creation Rule editor
         * @param {number} id Target Entity Type id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetEntityType(id: number, options?: any): AxiosPromise<EntityType> {
            return localVarFp.getTargetEntityType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of entity types that can be used as targets for post-entity creation rules. This excludes the source entity type itself, entity types with EAV storage, entity types with TIME_SERIES_SUB_ENTITY feature, and entity types that would create cyclical dependencies.
         * @summary Get valid target entity types for Post Entity Creation Rules
         * @param {number} entityType Source Entity Type to get valid targets for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetEntityTypes(entityType: number, options?: any): AxiosPromise<Array<EntityType>> {
            return localVarFp.getTargetEntityTypes(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Post Entity Creation Rule by id.
         * @param {number} id id of rule to update
         * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePostEntityCreationRule(id: number, postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options?: any): AxiosPromise<PostEntityCreationRuleDetail> {
            return localVarFp.updatePostEntityCreationRule(id, postEntityCreationRuleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PostEntityCreationRuleApi - object-oriented interface
 * @export
 * @class PostEntityCreationRuleApi
 * @extends {BaseAPI}
 */
export class PostEntityCreationRuleApi extends BaseAPI {
    /**
     * 
     * @summary Create a new Post Entity Creation Rule
     * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostEntityCreationRuleApi
     */
    public createPostEntityCreationRule(postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options?: any) {
        return PostEntityCreationRuleApiFp(this.configuration).createPostEntityCreationRule(postEntityCreationRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Post Entity Creation Rule by id.
     * @param {number} id id of rule to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostEntityCreationRuleApi
     */
    public deletePostEntityCreationRule(id: number, options?: any) {
        return PostEntityCreationRuleApiFp(this.configuration).deletePostEntityCreationRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single Post Entity Creation Rule by id if it exists.
     * @param {number} id id of rule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostEntityCreationRuleApi
     */
    public getPostEntityCreationRule(id: number, options?: any) {
        return PostEntityCreationRuleApiFp(this.configuration).getPostEntityCreationRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all Post Entity Creation Rules for the given entityType.
     * @param {number} entityType Entity Type to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostEntityCreationRuleApi
     */
    public getPostEntityCreationRules(entityType: number, options?: any) {
        return PostEntityCreationRuleApiFp(this.configuration).getPostEntityCreationRules(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the selected target entity type for rule administrators. Authorized by EntityType.ADMIN rather than the caller\'s Entity Type scope, so an administrator can load any target the target picker offers. Confined to the caller\'s effective organization; an entity type in another organization is reported exactly as a missing one.
     * @summary Get one target entity type for the Post Entity Creation Rule editor
     * @param {number} id Target Entity Type id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostEntityCreationRuleApi
     */
    public getTargetEntityType(id: number, options?: any) {
        return PostEntityCreationRuleApiFp(this.configuration).getTargetEntityType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of entity types that can be used as targets for post-entity creation rules. This excludes the source entity type itself, entity types with EAV storage, entity types with TIME_SERIES_SUB_ENTITY feature, and entity types that would create cyclical dependencies.
     * @summary Get valid target entity types for Post Entity Creation Rules
     * @param {number} entityType Source Entity Type to get valid targets for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostEntityCreationRuleApi
     */
    public getTargetEntityTypes(entityType: number, options?: any) {
        return PostEntityCreationRuleApiFp(this.configuration).getTargetEntityTypes(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Post Entity Creation Rule by id.
     * @param {number} id id of rule to update
     * @param {PostEntityCreationRuleRequest} [postEntityCreationRuleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostEntityCreationRuleApi
     */
    public updatePostEntityCreationRule(id: number, postEntityCreationRuleRequest?: PostEntityCreationRuleRequest, options?: any) {
        return PostEntityCreationRuleApiFp(this.configuration).updatePostEntityCreationRule(id, postEntityCreationRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
